import throttle from 'lodash/throttle';

const $ = jQuery.noConflict();
const mainHeader = document.querySelector('.main-header');


function toggleMobileMenu() {
    const hamburger = document.querySelector('.hamburger');
    const mainNavigation = document.querySelector('.main-navigation');
    const menuClose = document.querySelector('.menu-close');

    hamburger.addEventListener('click', ev => {
        ev.preventDefault()
        mainNavigation.classList.add('visible');
    });

    menuClose.addEventListener('click', ev => {
        ev.preventDefault()
        mainNavigation.classList.remove('visible');
    });
}

// function subMenus() {
//     const menuItemsParent = document.querySelectorAll('.menu-item-has-children > a');
//
//
//     menuItemsParent.forEach((menuItem) => {
//         menuItem.addEventListener('click', (ev) => {
//             ev.preventDefault();
//             const subMenu = menuItem.nextElementSibling;
//             const $subMenu = $(subMenu);
//             $subMenu.slideToggle();
//         })
//     })
//
// }

function offsetAdminBar() {
    const wpAdminBar = document.querySelector('#wpadminbar');
    const headerHeight = mainHeader.offsetHeight;
    const spacer = document.createElement('div');
    spacer.classList.add('header-spacer');
    spacer.style.height = headerHeight + 'px';
    document.querySelector('.header-main-footer-wrap').insertBefore(spacer, mainHeader);
    if (wpAdminBar) {
        const heightAdminBar = wpAdminBar.offsetHeight;
        mainHeader.style.top = heightAdminBar + 'px';
        // document.body.style.paddingTop = heightAdminBar +'px';
    }
}

let lastScrollTop = 0;

function checkScroll() {
    const scrollY = window.scrollY;
    const direction = scrollY > lastScrollTop ? 'down' : 'up';

    if (scrollY > 100) {
        mainHeader.classList.add('header-invert');
    } else {
        mainHeader.classList.remove('header-invert');
    }

    lastScrollTop = scrollY;
    if (scrollY === 0 || direction === 'up') {
        mainHeader.classList.remove('header-hidden');
    } else {
        mainHeader.classList.add('header-hidden');
    }
}

function stickyMenu() {
    window.addEventListener('scroll', throttle(checkScroll, 200));
}


export default function () {
    toggleMobileMenu();
    // subMenus();
    // offsetAdminBar();
    stickyMenu();

}